import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  buildConfig,
  buildGenerate,
  getBuildStatus,
  addWebhook,
  addWebhookEvent,
  eventList,
  deleteEvent,
  webhookEventList,
} from "../../services/profile";

@Module({
  namespaced: true,
})
export default class profile extends VuexModule {
  // state
  marketList = [];
  catalogTree = [];
  history = [];
  //action
  @Action
  public async eventList() {
    try {
      return await eventList();
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async deleteEvent(payload) {
    try {
      return await deleteEvent(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async webhookEventList(payload) {
    try {
      return await webhookEventList(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async addWebhook(payload) {
    try {
      return await addWebhook(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async addWebhookEvent(payload) {
    try {
      return await addWebhookEvent(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async buildConfig(payload) {
    try {
      return await buildConfig(payload);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async buildGenerate(payload) {
    try {
      return await buildGenerate(payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async buildStatusAction(payload) {
    try {
      const data = await getBuildStatus(payload);
      this.context.commit("setHistory", data.data.response);
    } catch (error) {
      throw error;
    }
  }
  // mutations
  @Mutation
  public setHistory(data: any) {
    this.history = data;
  }

  // getters
  get GetHistory() {
    return this.history;
  }
}
